import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';

class Modal extends PureComponent {

  render() {
    const { toogle, isOpen, children } = this.props;

    return (
      <ReactModal
        className="planet-modal"
        overlayClassName="planet-modal-overlay"
        contentLabel="da"
        isOpen={isOpen}>
        {
          toogle && <button
            type="button"
            className="btn-close-modal btn btn-primary btn-circle"
            onClick={toogle}>x</button>
        }
        {children}
      </ReactModal>
    );
  }
}

Modal.propTypes = {};
Modal.defaultProps = {};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Render/Modal/Modal.js